export default "__VITE_PUBLIC_ASSET__3ced8793__"